import { ROLES } from "../constants/roles";

/**
 * Pravo izmene u okviru organizacione jedinice: Admin svuda, Rukovodilac
 * samo u svojoj jedinici. Zaposleni i nalozi bez dodeljene role nemaju
 * pravo izmene — server iste zahteve odbija sa 403.
 */
export const hasUnitEditPermission = (user, unit_id, level) => {
  if (!user) {
    return false;
  }
  if (user.role_id === ROLES.SUPER_ADMIN) {
    return true;
  }
  return (
    user.role_id === ROLES.MANAGER &&
    user.organization_unit_id === unit_id &&
    user.level === level
  );
};
